import React, { useState } from "react"
import formatLimit from "@/utils/formatLimit"
import Line from "../Line"
import Button from "@/base-components/Button"
import Lucide from "@/base-components/Lucide"
import dynamic from "next/dynamic"
import Link from "next/link"
import { Span } from "next/dist/trace"
import clsx from "clsx"
import { useUserProfile } from "@/hooks/useUserProfile"
import displayOdds from "@/utils/displayOdds"
const CandleStick = dynamic(() => import("../CandleStick"))

const customSort = (a, b) => {
  if (a === "OddsFantasy") {
    return -1
  }
  if (b === "OddsFantasy") {
    return 1
  }

  if (a === "Pinnacle") {
    return -1
  }
  if (b === "Pinnacle") {
    return 1
  }

  return 0
}

const index = ({ bet }) => {
  const { data: profile } = useUserProfile()

  const sportbooks = Object.keys(bet.market_info.market_odds)
  sportbooks.sort(customSort)
  const oddsHome = sportbooks.map(
    book => bet.market_info.market_odds[book]?.[0] || 0
  )
  const oddsAway = sportbooks.map(
    book => bet.market_info.market_odds[book]?.[1] || 0
  )
  const thirdOdds = sportbooks.map(
    book => bet.market_info.market_odds[book]?.[2] || 0
  )
  const pinnacleOddsHome = bet.market_info.market_odds["Pinnacle"]?.[0] || 0
  const pinnacleOddsAway = bet.market_info.market_odds["Pinnacle"]?.[1] || 0
  const thirdPinnacleOdds = bet.market_info.market_odds["Pinnacle"]?.[2] || 0
  const oddsFantasyOddsHome =
    bet.market_info.market_odds["OddsFantasy"]?.[0] || 0
  const oddsFantasyOddsAway =
    bet.market_info.market_odds["OddsFantasy"]?.[1] || 0
  const thirdOddsFantasyOdds =
    bet.market_info.market_odds["OddsFantasy"]?.[2] || 0
  const index = bet.market_info.bet_names.indexOf(bet?.bet)
  const [showCandleStick, setShowCandleStick] = useState(false)
  const [sportsbook, setSportsBook] = useState(null)

  const showCandle = bet => {
    // setBet(bet)
    setShowCandleStick(true)
  }

  return (
    <>
      {showCandleStick && (
        <CandleStick
          showCandleStick={showCandleStick}
          setShowCandleStick={setShowCandleStick}
          bet={bet}
          sportsbook={sportsbook}
        />
      )}
      <div className="overflow-y-scroll">
        <div
          className={`text-center grid grid-cols-[repeat(17,minmax(0,1fr))] grid-rows-${sportbooks.length + 2} border border-white/[0.12] rounded-lg `}
        >
          <div className="border-b-0 !text-[8px] border-l-0 border-r-0 border-0 flex justify-center items-center col-span-1 row-span-2  border-white/[0.12]  p-4">
            Bookmaker
          </div>
          <div className="text-center col-span-5 border border-white/[0.12] border-b-0 border-t-0 border-r-0  p-2">
            {bet.market_info.bet_names[0]}
          </div>
          <div className="text-center col-span-5 border border-b-0 border-t-0 border-r-0   border-white/[0.12]  p-2">
            {bet.market_info.bet_names[1]}
          </div>
          <div className="text-center col-span-5 border border-b-0 border-t-0 border-r-0   border-white/[0.12]  p-2">
            {bet.market_info.bet_names[2]}
          </div>
          <div className="flex justify-center items-center border border-b-0 border-t-0 border-r-0  col-span-1   row-span-2 border-white/[0.12] p-2">
            Vig
          </div>
          <div className="col-span-1 border border-white/[0.12] border-b-0 border-r-0  p-2">
            limit
          </div>{" "}
          <div className="col-span-1 border border-white/[0.12] border-b-0 border-r-0 p-2">
            ev
          </div>{" "}
          <div className="col-span-1 border border-white/[0.12] border-b-0 border-r-0 p-2">
            odds
          </div>{" "}
          <div className="col-span-2 border border-white/[0.12] border-b-0 border-r-0 p-2">
            Lines
          </div>
          <div className="col-span-1 border border-white/[0.12] border-b-0 border-r-0  p-2">
            limit
          </div>{" "}
          <div className="col-span-1 border border-white/[0.12] border-b-0 border-r-0 p-2">
            ev
          </div>{" "}
          <div className="col-span-1 border border-white/[0.12] border-b-0 border-r-0 p-2">
            odds
          </div>{" "}
          <div className="col-span-2 border border-white/[0.12] border-b-0 border-r-0 p-2">
            Lines
          </div>
          <div className="col-span-1 border border-white/[0.12] border-b-0 border-r-0  p-2">
            limit
          </div>{" "}
          <div className="col-span-1 border border-white/[0.12] border-b-0 border-r-0 p-2">
            ev
          </div>{" "}
          <div className="col-span-1 border border-white/[0.12] border-b-0 border-r-0 p-2">
            odds
          </div>{" "}
          <div className="col-span-2 border border-white/[0.12] border-b-0 border-r-0 p-2">
            Lines
          </div>
          <div
            style={{
              gridRowEnd: `span ${sportbooks.length}`,
            }}
            className={`flex justify-center items-center col-start-5 col-end-7  row-span-${sportbooks.length} border border-b-0 border-r-0 border-white/[0.12] px-2`}
          >
            <Line
              sportbooks={sportbooks}
              odds={oddsHome}
              pinnacleOdds={pinnacleOddsHome}
              oddsFantasyOdds={oddsFantasyOddsHome}
              home={index === 0 ? true : false}
            />
          </div>
          <div
            style={{
              gridRowEnd: `span ${sportbooks.length}`,
            }}
            className={`flex justify-center items-center col-start-10 col-end-12 row-span-${sportbooks.length} border border-b-0 border-r-0 border-white/[0.12]  px-2`}
          >
            <Line
              sportbooks={sportbooks}
              odds={oddsAway}
              pinnacleOdds={pinnacleOddsAway}
              oddsFantasyOdds={oddsFantasyOddsAway}
              home={index === 1 ? true : false}
            />
          </div>
          <div
            style={{
              gridRowEnd: `span ${sportbooks.length}`,
            }}
            className={`flex justify-center items-center !col-[15/span_2] row-span-${sportbooks.length} border border-b-0 border-r-0 border-white/[0.12]  px-2`}
          >
            <Line
              sportbooks={sportbooks}
              odds={thirdOdds}
              pinnacleOdds={thirdPinnacleOdds}
              oddsFantasyOdds={thirdOddsFantasyOdds}
              home={index === 1 ? true : false}
            />
          </div>
          {sportbooks.map((sportbook, index) => {
            return (
              <>
                <div
                  style={{ gridRowStart: index + 3 }}
                  className={`flex justify-between text-left   col-start-1 col-end-1 border border-b-0 border-l-0 border-r-0 border-white/[0.12] p-1 `}
                >
                  <span className="flex justify-center !text-[8px] items-center">
                    {sportbook !== "OddsFantasy" ? (
                      // <Link
                      //   href={
                      //     sportbook !== "OddsFantasy"
                      //       ? bet.market_info?.market_urls?.[sportbook]
                      //       : "#"
                      //   }
                      //   legacyBehavior
                      // >
                        <a
                          href={
                            sportbook !== "OddsFantasy"
                              ? bet.market_info?.market_urls?.[sportbook]
                              : "#"
                          }
                          className="text-purple"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {sportbook}
                        </a>
                      // </Link>
                    ) : (
                      <span className="!text-[8px] ">{sportbook}</span>
                    )}
                  </span>
                  {sportbook !== "OddsFantasy" && (
                    <div
                      onClick={() => {
                        setSportsBook(sportbook)
                        setShowCandleStick(true)
                      }}
                      className="flex justify-center items-center hover:cursor-pointer"
                    >
                      <Lucide
                        className="text-purple-light h-3 mr-0"
                        icon="ChartCandlestick"
                      />
                    </div>
                  )}
                </div>
                <div
                  style={{ gridRowStart: index + 3 }}
                  className={`flex justify-center items-center col-span-1 border border-b-0 border-r-0 border-white/[0.12] p-2`}
                >
                  {formatLimit(bet.market_info.market_limits?.[sportbook]?.[0])}
                </div>{" "}
                <div
                  style={{ gridRowStart: index + 3 }}
                  className={clsx([
                    `flex justify-center items-center  col-span-1 border border-b-0 border-r-0 border-white/[0.12] p-2`,
                    bet?.market_info?.market_evs?.[sportbook]?.[0] < 0 &&
                      "text-customRed",
                    bet?.market_info?.market_evs?.[sportbook]?.[0] > 0 &&
                      "text-customGreen",
                  ])}
                >
                  {bet.market_info.market_evs[sportbook]
                    ? (bet.market_info.market_evs[sportbook][0] * 100).toFixed(
                        2
                      ) + "%"
                    : "0.0"}
                </div>{" "}
                <div
                  style={{ gridRowStart: index + 3 }}
                  className={`flex justify-center items-center col-span-1 border border-b-0 border-r-0 border-white/[0.12] p-2`}
                >
                  {bet.market_info.market_odds[sportbook]
                    ? displayOdds(
                        profile?.oddsFormat,
                        bet.market_info.market_odds[sportbook][0]
                      )
                    : "N/A"}
                </div>{" "}
                <div
                  style={{ gridRowStart: index + 3 }}
                  className={`flex justify-center items-center col-start-7 col-span-1 border border-b-0 border-r-0 border-white/[0.12] p-2`}
                >
                  {formatLimit(bet.market_info.market_limits?.[sportbook]?.[1])}
                </div>{" "}
                <div
                  style={{ gridRowStart: index + 3 }}
                  className={clsx([
                    `flex justify-center items-center  col-start-8  col-span-1 border border-b-0 border-r-0 border-white/[0.12] p-2`,
                    bet?.market_info?.market_evs?.[sportbook]?.[1] < 0 &&
                      "text-customRed",
                    bet?.market_info?.market_evs?.[sportbook]?.[1] > 0 &&
                      "text-customGreen",
                  ])}
                >
                  {bet.market_info.market_evs[sportbook]
                    ? (bet.market_info.market_evs[sportbook][1] * 100).toFixed(
                        2
                      ) + "%"
                    : "0.0"}
                </div>{" "}
                <div
                  style={{ gridRowStart: index + 3 }}
                  className={`flex justify-center items-center col-start-9 col-span-1 border border-b-0 border-r-0 border-white/[0.12] p-2`}
                >
                  {bet.market_info.market_odds[sportbook]
                    ? displayOdds(
                        profile?.oddsFormat,
                        bet.market_info.market_odds[sportbook][1]
                      )
                    : "N/A"}
                </div>{" "}
                <div
                  style={{ gridRowStart: index + 3 }}
                  className={`flex justify-center items-center col-start-12 col-span-1  border border-b-0 border-r-0 border-white/[0.12]  px-2`}
                >
                  {formatLimit(bet.market_info.market_limits?.[sportbook]?.[2])}
                </div>
                <div
                  style={{ gridRowStart: index + 3 }}
                  className={clsx([
                    `flex justify-center items-center  col-start-13  col-span-1 border border-b-0 border-r-0 border-white/[0.12] p-2`,
                    bet?.market_info?.market_evs?.[sportbook]?.[2] < 0 &&
                      "text-customRed",
                    bet?.market_info?.market_evs?.[sportbook]?.[2] > 0 &&
                      "text-customGreen",
                  ])}
                >
                  {bet.market_info.market_evs[sportbook]
                    ? (bet.market_info.market_evs[sportbook][2] * 100).toFixed(
                        2
                      ) + "%"
                    : "0.0"}
                </div>{" "}
                <div
                  style={{ gridRowStart: index + 3 }}
                  className={`flex justify-center items-center  col-[14/span_1]  row-start-[${index + 3}] row-end-[${index + 4}] border border-b-0 border-r-0 border-white/[0.12]  px-2`}
                >
                  {bet.market_info.market_odds[sportbook]
                    ? displayOdds(
                        profile?.oddsFormat,
                        bet.market_info.market_odds[sportbook][2]
                      )
                    : "N/A"}
                </div>
                <div
                  style={{ gridRowStart: index + 3 }}
                  className={` flex justify-center items-center  col-[17/span_1] border border-b-0 border-r-0 border-white/[0.12] p-2`}
                >
                  {bet.market_info.market_vig[sportbook]
                    ? bet.market_info.market_vig[sportbook].toFixed(2) + "%"
                    : "0.0"}
                </div>{" "}
              </>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default index
